import { serialize } from "../gtx/gtx";
/**
 *
 * Encodes the gtx using ASN.1.
 * @returns the gtx encoded
 */
export function encodeTransaction(gtx) {
    return serialize(gtx);
}
//# sourceMappingURL=encodeTransaction.js.map